export const enum Event {
  LIVESTREAM = 'livestream',
  LIVE = 'live'
}
